import { type FC, useContext, useMemo } from 'react'
import { useIntl } from 'react-intl'

import { FormHelperText } from 'base-ui'

import { LoginRegistrationRegistrationFormStateContext } from '../../context/LoginRegistrationRegistrationFormStateContext'
import {
  dateOfBirthGetDays,
  dateOfBirthGetMonths,
  dateOfBirthGetYears,
} from '../../dateOfBirthDropDownUtil'
import { LoginRegistrationDateDropdown } from '../LoginRegistrationDateDropdown/LoginRegistrationDateDropdown'

export const LoginRegistrationBirthDaySelect: FC = () => {
  const intl = useIntl()
  const days = useMemo(
    () =>
      dateOfBirthGetDays(
        intl.formatMessage({
          id: 'registration.birthDate.DD',
        }),
        true,
      ),
    [intl],
  )
  const months = useMemo(
    () =>
      dateOfBirthGetMonths(
        intl.formatMessage({
          id: 'registration.birthDate.MM',
        }),
        true,
      ),
    [intl],
  )
  const years = useMemo(
    () =>
      dateOfBirthGetYears(
        intl.formatMessage({
          id: 'registration.birthDate.YYYY',
        }),
        true,
      ),
    [intl],
  )

  const { registrationFormState } = useContext(
    LoginRegistrationRegistrationFormStateContext,
  )
  const { model } = registrationFormState
  const error =
    model.validator.getFirstErrorFor('birthDaySelectedDay') ??
    model.validator.getFirstErrorFor('birthDaySelectedMonth') ??
    model.validator.getFirstErrorFor('birthDaySelectedYear')

  return (
    <div className="mb-6 flex flex-col gap-0">
      <div className="mb-1 font-medium">
        {`${intl.formatMessage({ id: 'general.label.birthday' })}*`}
      </div>
      <div className="flex max-w-sm flex-row gap-2">
        <LoginRegistrationDateDropdown
          data-qa-id="register-form-birthdayDay"
          entries={days}
          id="birthdayDay"
          label={intl.formatMessage({ id: 'general.label.birthday.day' })}
          selectField="birthDaySelectedDay"
        />
        <LoginRegistrationDateDropdown
          data-qa-id="register-form-birthdayMonth"
          entries={months}
          id="birthdayMonth"
          label={intl.formatMessage({ id: 'general.label.birthday.month' })}
          selectField="birthDaySelectedMonth"
        />
        <LoginRegistrationDateDropdown
          data-qa-id="register-form-birthdayYear"
          entries={years}
          id="birthdayYear"
          label={intl.formatMessage({ id: 'general.label.birthday.year' })}
          selectField="birthDaySelectedYear"
        />
      </div>
      {error ? <FormHelperText error>{error}</FormHelperText> : null}
    </div>
  )
}
